import React, { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './AdminPanelPage.css';

function EstadoPorCategoria({ modo, categorias }) {
  const [estadoCategorias, setEstadoCategorias] = useState({});

  useEffect(() => {
    async function carregarEstados() {
      const novoEstado = {};
      for (const cat of categorias) {
        const ref = doc(db, `modos/${modo}/categorias/${cat.id}`);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          novoEstado[cat.id] = snap.data();
        } else {
          novoEstado[cat.id] = {
            aberto: false,
            fechado: true,
            disponivel: true,
            indisponivel: false,
            mensagem: ''
          };
        }
      }
      setEstadoCategorias(novoEstado);
    }

    if (categorias.length > 0) {
      carregarEstados();
    }
  }, [modo, categorias]);

  const atualizarCampo = async (categoriaId, campo, valor) => {
    const dadosAtuais = estadoCategorias[categoriaId] || {};
    const novosDados = {
      ...dadosAtuais,
      [campo]: valor
    };

    // Regras de coerência
    if (campo === 'aberto') {
      novosDados.fechado = !valor;
    }
    if (campo === 'fechado') {
      novosDados.aberto = !valor;
    }
    if (campo === 'disponivel') {
      novosDados.indisponivel = !valor;
    }

    setEstadoCategorias((prev) => ({
      ...prev,
      [categoriaId]: novosDados
    }));

    await setDoc(doc(db, `modos/${modo}/categorias/${categoriaId}`), novosDados, { merge: true });
  };

  return (
    <div className="admin-datas-categorias-bloco">
      <h3>Estado por Categoria</h3>
      {categorias.map((cat) => {
        const estado = estadoCategorias[cat.id] || {};
        return (
          <div key={cat.id} className="admin-categoria-linha">
            <strong>{cat.nome || cat.id}</strong>

            <div style={{ display: 'flex', gap: '10px', marginTop: '6px' }}>
              <button
                onClick={() => atualizarCampo(cat.id, 'aberto', true)}
                disabled={estado.aberto}
              >
                ABRIR
              </button>
              <button
                onClick={() => atualizarCampo(cat.id, 'fechado', true)}
                disabled={estado.fechado}
              >
                FECHAR
              </button>
              <label>
                <input
                  type="checkbox"
                  checked={estado.disponivel || false}
                  onChange={(e) => atualizarCampo(cat.id, 'disponivel', e.target.checked)}
                />
                Disponível ao público
              </label>
            </div>

            {estado.fechado && (
              <label style={{ marginTop: '8px' }}>
                Mensagem (opcional):
                <input
                  type="text"
                  value={estado.mensagem || ''}
                  onChange={(e) => atualizarCampo(cat.id, 'mensagem', e.target.value)}
                  placeholder="Escreve a mensagem a exibir quando estiver fechado..."
                  style={{ width: '100%', marginTop: '4px' }}
                />
              </label>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default EstadoPorCategoria;